<template>
  <div id="wrapper">
    <Nav :message="message" />
    <APInfoBox />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import APInfoBox from '@/components/finance/APInfoBox.vue'

export default {
  name: 'ap-info',
  props: ['message'],
  components: {
    Nav,
    APInfoBox
  }
}
</script>